import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { apiUrl } from "../../../services/api";

type RegistrationHeaderProps = {
    isText?: Boolean
}

const RegistrationHeader: React.FC<RegistrationHeaderProps> = ({ isText = true }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
                mb: 4,
                mt: 2,
                textAlign: 'center'
            }}
        >
            <Box>
                <img src={`${apiUrl}/img/logo-2-sysprojud`} height={70} alt="Logo SysProJud"></img>
                        <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            sx={{ mt: 0.5 }}
                        >
                            Conheça a ferramenta que vai levar seu escritório para o próximo nível com até 300% mais eficiência processual.
                        </Typography>
                {isText && (
                    <>
                        <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            sx={{ mt: 0.5 }}
                        >
                            Registre-se e aproveite 30 dias grátis
                        </Typography>
                    </>
                )}
            </Box>
        </Box>
    );
};

export default RegistrationHeader;